import React from "react";
import { Footer, Header } from "../../shared/Layouts/LandingPageLayout";
import { BACKGROUND } from "../../assets";

function PrivacyPolicy() {
  return (
    <>
      <Header />
      <div
        className="w-full h-full  flex items-center justify-center mt-24 py-36 relative"
        style={{
          backgroundImage: `url(${BACKGROUND})`,
          backgroundSize: "cover",
        }}
      >
        <span className="text-[40px] font-bold text-primary-300">
          Privacy Policy
        </span>
        <div className="bg-lightGold w-full h-full absolute"></div>
      </div>
      <div className="flex items-center py-10 justify-center gap-y-10 flex-col lg:px-40 px-5">
        <div className="flex flex-col gap-y-4 items-start">
          <div className="flex flex-col text-[16px] font-normal items-start gap-y-2">
            <span className="text-[16px] font-semibold text-[#2A2E34]">
              Last updated:{" "}
              {`${new Date().getDate()} ${new Date().toLocaleString("default", {
                month: "long",
              })}, ${new Date().getFullYear()}`}
            </span>
            <p className="text-[16px] font-normal text-primary-300">
              Lis Pendens Anambra (“we”, “our”, or “the Platform”) is committed
              to protecting your privacy and ensuring that your personal data is
              handled securely and transparently. This Privacy Policy outlines
              how we collect, use, and safeguard your information when you use
              our platform.
            </p>
          </div>

          <div className="flex flex-col gap-y-4">
            <span className="text-[16px] font-semibold text-primary-300">
              1. Information We Collect
            </span>
            <div className="text-primary-300 text-[16px]">
              <p className="font-normal">
                We may collect the following categories of personal data:
              </p>

              <ul className="text-[16px] list-inside font-normal text-primary-300">
                <div>
                  <li className="list-disc">Personal Information</li>
                  <span>
                    {" "}
                    Full name, email address, phone number, and any additional
                    information you provide during registration or when
                    submitting a search or support request.
                  </span>
                </div>
                <div>
                  <li className="list-disc">Search Activity</li>
                  <span>
                    {" "}
                    Details of your property searches, including search
                    parameters (e.g. location, title number), and the results
                    generated.
                  </span>
                </div>
                <div>
                  <li className="list-disc">Technical Data</li>
                  <span>
                    {" "}
                    IP address, browser type, operating system, and usage data
                    collected through cookies and analytics tools.
                  </span>
                </div>
                <div>
                  <li className="list-disc">Uploaded Content</li>
                  <span>
                    {" "}
                    For authorized users (e.g. court registrars, admin users),
                    we collect information related to uploaded court cases and
                    litigation records.
                  </span>
                </div>
              </ul>
            </div>
          </div>
          <div className="flex flex-col gap-y-4">
            <span className="text-[16px] font-semibold text-primary-300">
              2. How We Use Your Information
            </span>
            <div className="text-primary-300 text-[16px]">
              <p className="font-normal">
                We use your data for the following purposes:
              </p>
              <ul className="list-inside">
                <li className="list-disc">
                  To provide access to Lis Pendens search services
                </li>
                <li className="list-disc">
                  To issue Certificates of Lis Pendens
                </li>
                <li className="list-disc">
                  To manage your user account and search history
                </li>
                <li className="list-disc">
                  To notify you about changes to the platform, system updates,
                  or legal notices
                </li>
                <li className="list-disc">
                  To improve platform security, performance, and usability
                </li>
                <li className="list-disc">
                  To communicate with you regarding support, inquiries, or legal
                  concerns
                </li>
              </ul>
            </div>
          </div>
          <div className="flex flex-col gap-y-4">
            <span className="text-[16px] font-semibold text-primary-300">
              3. Sharing of Information
            </span>
            <div className="text-primary-300 text-[16px]">
              <p className="font-normal">
                We do not sell or rent your personal information. However, we
                may share data with:
              </p>
              <ul className="list-inside">
                <li className="list-disc">
                  Relevant government or judicial authorities where legally
                  required
                </li>
                <li className="list-disc">
                  Our technology and infrastructure partners for the purpose of
                  maintaining the platform
                </li>
                <li className="list-disc">
                  Internal administrative and compliance teams for audit or
                  fraud prevention purposes
                </li>
              </ul>
            </div>
          </div>
          <div className="flex flex-col gap-y-4">
            <span className="text-lg font-semibold text-primary-300">
              4. Data Security
            </span>
            <div className="text-primary-300 text-[16px]">
              <p className="font-normal">
                We implement appropriate technical and organizational measures
                to protect your data from unauthorized access, alteration, or
                destruction. All sensitive information is stored securely and
                encrypted where applicable.
              </p>
            </div>
          </div>
          <div className="flex flex-col gap-y-4">
            <span className="text-lg font-semibold text-primary-300">
              5. Cookies and Tracking Technologies
            </span>
            <div className="text-primary-300 text-[16px]">
              <p className="font-normal">
                Lis Pendens Anambra uses cookies to enhance your experience and
                collect usage statistics. You may manage cookie preferences
                through your browser settings.
              </p>
            </div>
          </div>
          <div className="flex flex-col gap-y-4">
            <span className="text-lg font-semibold text-primary-300">
              6. Data Retention
            </span>
            <div className="text-primary-300 text-[16px]">
              <p className="font-normal">
                We retain your personal information for as long as necessary to
                fulfill the purposes outlined in this policy, or as required by
                law. Search history and certificates may be stored for reference
                or audit purposes.
              </p>
            </div>
          </div>
          <div className="flex flex-col gap-y-4">
            <span className="text-lg font-semibold text-primary-300">
              7. Your Rights
            </span>
            <div className="text-primary-300 text-[16px]">
              <p className="font-normal">You have the following rights:</p>
              <div>
                <ul className="list-inside">
                  <li className="list-disc">
                    Access your personal information
                  </li>
                  <li className="list-disc">
                    Correct inaccurate or outdated data
                  </li>
                  <li className="list-disc">
                    Request account deletion or data erasure
                  </li>
                  <li className="list-disc">
                    Object to certain processing activities
                  </li>
                </ul>

                <p className="font-normal">
                  To exercise these rights, please contact us at:
                  privacy@lispensens.en.gov.ng
                </p>
              </div>
            </div>
          </div>
          <div className="flex flex-col gap-y-4">
            <span className="text-lg font-semibold text-primary-300">
              8. Changes to This Policy
            </span>
            <div className="text-primary-300 text-[16px]">
              <p className="font-normal">
                We may update this Privacy Policy from time to time. When we do,
                the updated version will be posted on this page with the revised
                date.
              </p>
            </div>
          </div>

          <div className="flex flex-col gap-y-4">
            <span className="text-lg font-semibold text-primary-300">
              9. Contact Us
            </span>
            <div className="text-primary-300 text-[16px] flex flex-col gap-y-4">
              <p className="font-normal">
                For questions, feedback, or privacy-related concerns, please
                contact: Lis Pendens Anambra Support TeamJudiciary Complex,
                Independence Layout, Anambra, Nigeria
              </p>

              <div className="flex flex-col">
                <span>📧 Email: support@lispensens.an.gov.ng </span>
                <span> 📞 Phone: +234 701 234 5678</span>
              </div>
              <p>
                You may also lodge a complaint with the Nigeria Data Protection
                Commission (NDPC) if you believe your rights have been violated.
              </p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default PrivacyPolicy;
